var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwAruba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0V44.9996H-7.49933V0H60Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 29.9997V32.4997H-7.49933V29.9997H60ZM60 34.9996V37.4996H-7.49933V34.9996H60Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6221 2.625L46.3502 2.90625L46.6314 2.625H46.6221ZM46.9033 3.1875L46.6221 3.46875L46.9033 3.1875ZM46.3502 3.1875L46.0689 3.46875L46.3502 3.1875Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9033 3.46873L46.6221 3.7406L46.9033 3.45935M46.3502 3.45935L46.0689 3.7406L46.3502 3.45935Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 4.01251L46.9033 4.29376L47.1846 4.01251Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6215 4.01251L46.3496 4.29376L46.6309 4.01251H46.6215Z",
    fill: "#CC6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0687 4.01251L45.7969 4.29376L46.0781 4.01251H46.0687Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 4.29376L46.9033 4.57501L47.1846 4.29376ZM46.0689 4.29376L45.7971 4.57501L46.0783 4.29376H46.0689Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9033 4.56561L46.6221 4.84686L46.9033 4.56561ZM46.3502 4.56561L46.0689 4.84686L46.3502 4.56561Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 4.84686L47.1748 5.12811L47.4561 4.84686Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6686 3.1875L48.6092 10.5469L55.9873 12.5625L48.6373 14.4844L46.6686 21.8344L44.7092 14.4844L37.3592 12.5156L44.7092 10.5562L46.6779 3.20625L46.6686 3.1875Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8555 3.21492L48.7517 10.4059L56.6592 12.5662L48.7791 14.6266L46.6685 22.5062L44.5677 14.6259L36.6877 12.5152L44.5679 10.4145L46.5107 3.16136L46.6142 3.18907L46.824 3.10992L46.8628 3.18754L46.8555 3.21492ZM46.6747 3.88979L48.4673 10.6878L55.3161 12.5588L48.4962 14.3421L46.6693 21.1625L44.8512 14.3428L38.0313 12.516L44.8511 10.698L46.6747 3.88979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7969 4.84686L45.5156 5.12811L45.7969 4.84686Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 5.11877L47.1748 5.40002L47.4561 5.11877ZM45.7967 5.11877L45.5154 5.40002L45.7967 5.11877Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 5.40002L46.9033 5.68127L47.1846 5.40002ZM46.0689 5.40002L45.7971 5.68127L46.0783 5.40002H46.0689Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 5.67188L47.4561 5.95312L47.7373 5.67188Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0908 5.85938L46.9971 6.04688L47.0908 5.85938ZM45.9846 5.85938L45.8908 6.04688L45.9846 5.85938Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 5.67188L45.2344 5.95312L45.5156 5.67188Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 5.95312L47.4561 6.23438L47.7373 5.95312ZM45.5154 5.95312L45.2342 6.23438L45.5154 5.95312Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 6.22498L47.1748 6.50623L47.4561 6.22498ZM45.7967 6.22498L45.5154 6.50623L45.7967 6.22498Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 6.50623L47.7285 6.78748L48.0098 6.50623ZM45.2441 6.50623L44.9629 6.78748L45.2441 6.50623Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 6.77814L47.7285 7.05939L48.0098 6.77814ZM45.2441 6.77814L44.9629 7.05939L45.2441 6.77814Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 7.05939L47.7285 7.34064L48.0098 7.05939ZM45.2441 7.05939L44.9629 7.34064L45.2441 7.05939Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 7.34061L48.0098 7.61249L48.291 7.33124L48.2816 7.34061Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 7.34061L47.4561 7.61249L47.7373 7.33124M45.5154 7.33124L45.2342 7.61249L45.5154 7.33124Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9629 7.34061L44.6816 7.61249L44.9629 7.33124V7.34061Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 7.61249L48.0098 7.89374L48.291 7.61249H48.2816Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6436 7.79999L47.5498 7.98749L47.6436 7.79999ZM45.4311 7.79999L45.3373 7.98749L45.4311 7.79999Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9629 7.61249L44.6816 7.89374L44.9629 7.61249Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 7.89374L48.0098 8.17499L48.291 7.89374M44.9629 7.89374L44.6816 8.17499L44.9629 7.89374Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 8.16565L47.7285 8.4469L48.0098 8.16565ZM45.2441 8.16565L44.9629 8.4469L45.2441 8.16565Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 8.4375L48.2812 8.71875L48.5625 8.4375Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.916 8.625L47.8223 8.8125L47.916 8.625ZM45.1504 8.625L45.0566 8.8125L45.1504 8.625Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 8.4375L44.4092 8.71875L44.6904 8.4375Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 8.71875L48.2812 9L48.5625 8.71875ZM44.6906 8.71875L44.4094 9L44.6906 8.71875Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 9L48.0098 9.28125L48.291 9M44.9629 9L44.6816 9.28125L44.9629 9Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8438 9.28123L48.5625 9.5531L48.8438 9.27185V9.28123Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1879 9.45935L48.1035 9.64685L48.1973 9.45935M44.8785 9.45935L44.7848 9.64685L44.8785 9.45935Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4092 9.28123L44.1279 9.5531L44.4092 9.27185V9.28123Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8438 9.5531L48.5625 9.83435L48.8438 9.5531ZM44.4094 9.5531L44.1281 9.83435L44.4094 9.5531Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 9.82501L48.2812 10.1063L48.5625 9.82501ZM44.6906 9.82501L44.4094 10.1063L44.6906 9.82501Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.125 10.1063L48.8438 10.3875L49.125 10.1063Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 10.1063L48.2812 10.3875L48.5625 10.1063ZM44.6906 10.1063L44.4094 10.3875L44.6906 10.1063Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1377 10.1063L43.8564 10.3875L44.1377 10.1063ZM49.9502 10.3875L49.6689 10.6594L49.9502 10.3781V10.3875Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6689 10.3781L49.3877 10.6594L49.6689 10.3781ZM43.5752 10.3781L43.3033 10.6594L43.5846 10.3781H43.5752Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3129 10.3781L43.0316 10.6594L43.3129 10.3781ZM50.7754 10.6594L50.4941 10.9406L50.7754 10.6594Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5029 10.6594L50.2217 10.9406L50.5029 10.6594Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3965 10.6594L49.1152 10.9406L49.3965 10.6594Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.125 10.6594L48.8438 10.9406L49.125 10.6594ZM44.1375 10.6594L43.8563 10.9406L44.1375 10.6594Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8564 10.6594L43.5752 10.9406L43.8564 10.6594Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75 10.6594L42.4688 10.9406L42.75 10.6594Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4691 10.6594L42.1973 10.9406L42.4785 10.6594H42.4691Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8809 10.9313L51.5996 11.2125L51.8809 10.9313Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6094 10.9313L51.3281 11.2125L51.6094 10.9313Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3281 10.9313L51.0469 11.2125L51.3281 10.9313Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2217 10.9313L49.9404 11.2125L50.2217 10.9313Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7627 11.025L49.5752 11.1188L49.7627 11.025ZM43.3971 11.025L43.2096 11.1188L43.3971 11.025Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0312 10.9313L42.75 11.2125L43.0312 10.9313Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9248 10.9313L41.6436 11.2125L41.9248 10.9313Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6436 10.9313L41.3623 11.2125L41.6436 10.9313Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3721 10.9313L41.0908 11.2125L41.3721 10.9313ZM52.7158 11.2125L52.4346 11.4938L52.7158 11.2125Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4346 11.2125L52.1533 11.4938L52.4346 11.2125Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1621 11.2125L51.8809 11.4938L52.1621 11.2125Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0566 11.2125L50.7754 11.4938L51.0566 11.2125Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5967 11.3063L50.4092 11.4L50.5967 11.3063ZM42.5717 11.3063L42.3842 11.4L42.5717 11.3063Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1973 11.2125L41.916 11.4938L42.1973 11.2125Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0908 11.2125L40.8096 11.4938L41.0908 11.2125Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8184 11.2125L40.5371 11.4938L40.8184 11.2125Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5373 11.2125L40.2561 11.4938L40.5373 11.2125ZM53.5498 11.4938L53.2686 11.7656L53.5498 11.4844V11.4938Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2686 11.4844L52.9873 11.7656L53.2686 11.4844Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8809 11.4844L51.5996 11.7656L51.8809 11.4844Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4219 11.5781L51.2344 11.6719L51.4219 11.5781ZM41.7375 11.5781L41.55 11.6719L41.7375 11.5781Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3721 11.4844L41.0908 11.7656L41.3721 11.4844Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9844 11.4844L39.7031 11.7656L39.9844 11.4844Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7129 11.4844L39.4316 11.7656L39.7129 11.4844Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.375 11.7656L54.0938 12.0469L54.375 11.7656Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0941 11.7656L53.8223 12.0469L54.1035 11.7656H54.0941Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9877 11.7656L52.7158 12.0469L52.9971 11.7656H52.9877ZM40.2564 11.7656L39.9846 12.0469L40.2658 11.7656H40.2564Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1592 11.7656L38.8779 12.0469L39.1592 11.7656Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8777 11.7656L38.5965 12.0469L38.8777 11.7656ZM55.209 12.0469L54.9277 12.3187L55.209 12.0375V12.0469Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9375 12.0375L54.6562 12.3187L54.9375 12.0375Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8223 12.0375L53.541 12.3187L53.8223 12.0375Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3623 12.1312L53.1748 12.225L53.3623 12.1312ZM39.7967 12.1312L39.6092 12.225L39.7967 12.1312Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4316 12.0375L39.1504 12.3187L39.4316 12.0375Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3252 12.0375L38.0439 12.3187L38.3252 12.0375Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0439 12.0375L37.7627 12.3187L38.0439 12.0375Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0342 12.3187L55.7529 12.6L56.0342 12.3187Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7627 12.3187L55.4814 12.6L55.7627 12.3187Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6562 12.3187L54.375 12.6L54.6562 12.3187ZM38.5969 12.3187L38.3156 12.6L38.5969 12.3187Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 12.3187L37.2188 12.6L37.5 12.3187Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2191 12.3187L36.9379 12.6L37.2191 12.3187ZM56.5879 12.6L56.3066 12.8719L56.5879 12.5906V12.6Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.209 12.5906L54.9277 12.8719L55.209 12.5906ZM38.0527 12.5906L37.7715 12.8719L38.0527 12.5906Z",
    fill: "#CC6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6561 12.5906L36.3842 12.8719L36.6654 12.5906M56.0342 12.8719L55.7529 13.1531L56.0342 12.8719Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7627 12.8719L55.4814 13.1531L55.7627 12.8719Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6562 12.8719L54.375 13.1531L54.6562 12.8719ZM38.5969 12.8719L38.3156 13.1531L38.5969 12.8719Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 12.8719L37.2188 13.1531L37.5 12.8719Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2188 12.8719L36.9375 13.1531L37.2188 12.8719Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.209 13.1531L54.9277 13.425L55.209 13.1437V13.1531Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9375 13.1531L54.6562 13.425L54.9375 13.1437V13.1531Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8223 13.1531L53.541 13.425L53.8223 13.1437V13.1531Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3623 13.2375L53.1748 13.3312L53.3623 13.2375ZM39.7967 13.2375L39.6092 13.3312L39.7967 13.2375Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4316 13.1531L39.1504 13.425L39.4316 13.1437V13.1531Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3252 13.1531L38.0439 13.425L38.3252 13.1437V13.1531Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0438 13.1531L37.7625 13.425L38.0438 13.1437M54.375 13.425L54.0938 13.7062L54.375 13.425Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0941 13.425L53.8223 13.7062L54.1035 13.425H54.0941Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9877 13.425L52.7158 13.7062L52.9971 13.425H52.9877ZM40.2564 13.425L39.9846 13.7062L40.2658 13.425H40.2564Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1592 13.425L38.8779 13.7062L39.1592 13.425Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8779 13.425L38.5967 13.7062L38.8779 13.425Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5498 13.7063L53.2686 13.9781L53.5498 13.6969V13.7063Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2686 13.7063L52.9873 13.9781L53.2686 13.6969V13.7063Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8809 13.7063L51.5996 13.9781L51.8809 13.6969V13.7063Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4219 13.7906L51.2344 13.8844L51.4219 13.7906ZM41.7375 13.7906L41.55 13.8844L41.7375 13.7906Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3721 13.7063L41.0908 13.9781L41.3721 13.6969V13.7063Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9844 13.7063L39.7031 13.9781L39.9844 13.6969V13.7063Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7127 13.7063L39.4314 13.9781L39.7127 13.6969M52.7158 13.9781L52.4346 14.2594L52.7158 13.9781Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4346 13.9781L52.1533 14.2594L52.4346 13.9781Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1621 13.9781L51.8809 14.2594L52.1621 13.9781Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0566 13.9781L50.7754 14.2594L51.0566 13.9781Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5967 14.0625L50.4092 14.1562L50.5967 14.0625ZM42.5717 14.0625L42.3842 14.1562L42.5717 14.0625Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1973 13.9781L41.916 14.2594L42.1973 13.9781Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0908 13.9781L40.8096 14.2594L41.0908 13.9781Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8184 13.9781L40.5371 14.2594L40.8184 13.9781Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5375 13.9781L40.2562 14.2594L40.5375 13.9781ZM51.8813 14.2594L51.6094 14.5313L51.8906 14.25L51.8813 14.2594Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6094 14.25L51.3281 14.5312L51.6094 14.25Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3281 14.25L51.0469 14.5312L51.3281 14.25Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2217 14.25L49.9404 14.5312L50.2217 14.25Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7627 14.3438L49.5752 14.4375L49.7627 14.3438ZM43.3971 14.3438L43.2096 14.4375L43.3971 14.3438Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0312 14.25L42.75 14.5312L43.0312 14.25Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9248 14.25L41.6436 14.5312L41.9248 14.25Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6436 14.25L41.3623 14.5312L41.6436 14.25Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3721 14.25L41.0908 14.5312L41.3721 14.25Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7754 14.5312L50.4941 14.8125L50.7754 14.5312Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5029 14.5312L50.2217 14.8125L50.5029 14.5312Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3965 14.5312L49.1152 14.8125L49.3965 14.5312Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.125 14.5312L48.8438 14.8125L49.125 14.5312ZM44.1375 14.5312L43.8563 14.8125L44.1375 14.5312Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8564 14.5312L43.5752 14.8125L43.8564 14.5312Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75 14.5312L42.4688 14.8125L42.75 14.5312Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4689 14.5312L42.1971 14.8125L42.4783 14.5312M49.9502 14.8125L49.6689 15.0938L49.9502 14.8125Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6689 14.8125L49.3877 15.0938L49.6689 14.8125ZM43.5752 14.8125L43.3033 15.0938L43.5846 14.8125H43.5752Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3125 14.8125L43.0312 15.0938L43.3125 14.8125ZM49.125 15.0938L48.8438 15.3656L49.125 15.0844V15.0938Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 15.0937L48.2812 15.3656L48.5625 15.0844M44.6906 15.0844L44.4094 15.3656L44.6906 15.0844Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1377 15.0937L43.8564 15.3656L44.1377 15.0844V15.0937Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 15.3656L48.2812 15.6469L48.5625 15.3656ZM44.6906 15.3656L44.4094 15.6469L44.6906 15.3656Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8438 15.6375L48.5625 15.9188L48.8438 15.6375Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1879 15.825L48.1035 16.0125L48.1973 15.825M44.8785 15.825L44.7848 16.0125L44.8785 15.825Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4092 15.6375L44.1279 15.9188L44.4092 15.6375Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8438 15.9188L48.5625 16.2L48.8438 15.9188ZM44.4094 15.9188L44.1281 16.2L44.4094 15.9188Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 16.1906L48.0098 16.4719L48.291 16.1906M44.9629 16.1906L44.6816 16.4719L44.9629 16.1906Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 16.4719L48.2812 16.7531L48.5625 16.4719Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.916 16.65L47.8223 16.8375L47.916 16.65ZM45.1504 16.65L45.0566 16.8375L45.1504 16.65Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 16.4719L44.4092 16.7531L44.6904 16.4719Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 16.7438L48.2812 17.025L48.5625 16.7438ZM44.6906 16.7438L44.4094 17.025L44.6906 16.7438Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 17.025L47.7285 17.3063L48.0098 17.025ZM45.2441 17.025L44.9629 17.3063L45.2441 17.025Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 17.2969L48.0098 17.5781L48.291 17.2969H48.2816Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6436 17.4844L47.5498 17.6719L47.6436 17.4844ZM45.4311 17.4844L45.3373 17.6719L45.4311 17.4844Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9629 17.2969L44.6816 17.5781L44.9629 17.2969Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 17.5781L48.0098 17.8594L48.291 17.5781M44.9629 17.5781L44.6816 17.8594L44.9629 17.5781Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2816 17.85L48.0098 18.1312L48.291 17.85H48.2816Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 17.85L47.4561 18.1312L47.7373 17.85ZM45.5154 17.85L45.2342 18.1312L45.5154 17.85Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9629 17.85L44.6816 18.1312L44.9629 17.85Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 18.1312L47.7285 18.4125L48.0098 18.1312ZM45.2441 18.1312L44.9629 18.4125L45.2441 18.1312Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 18.4031L47.7285 18.6844L48.0098 18.4031ZM45.2441 18.4031L44.9629 18.6844L45.2441 18.4031Z",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0098 18.6844L47.7285 18.9656L48.0098 18.6844ZM45.2441 18.6844L44.9629 18.9656L45.2441 18.6844Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 18.9562L47.1748 19.2375L47.4561 18.9562ZM45.7967 18.9562L45.5154 19.2375L45.7967 18.9562Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 19.2375L47.4561 19.5187L47.7373 19.2375Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0908 19.425L46.9971 19.6125L47.0908 19.425ZM45.9846 19.425L45.8908 19.6125L45.9846 19.425Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 19.2375L45.2344 19.5187L45.5156 19.2375Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 19.5188L47.4561 19.7906L47.7373 19.5094M45.5154 19.5094L45.2342 19.7906L45.5154 19.5094Z",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 19.7906L46.9033 20.0719L47.1846 19.7906ZM46.0689 19.7906L45.7971 20.0719L46.0783 19.7906H46.0689Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 20.0625L47.1748 20.3438L47.4561 20.0625ZM45.7967 20.0625L45.5154 20.3438L45.7967 20.0625Z",
    fill: "#99CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 20.3438L47.1748 20.625L47.4561 20.3438ZM45.7967 20.3438L45.5154 20.625L45.7967 20.3438Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9033 20.625L46.6221 20.9062L46.9033 20.625ZM46.3502 20.625L46.0689 20.9062L46.3502 20.625Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 20.8969L46.9033 21.1781L47.1846 20.8969ZM46.0689 20.8969L45.7971 21.1781L46.0783 20.8969H46.0689Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 21.1781L46.9033 21.4594L47.1846 21.1781Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6215 21.1781L46.3496 21.4594L46.6309 21.1781H46.6215Z",
    fill: "#CC6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0687 21.1781L45.7969 21.4594L46.0781 21.1781H46.0687Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9033 21.7313L46.6221 22.0125L46.9033 21.7313ZM46.3502 21.7313L46.0689 22.0125L46.3502 21.7313Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9033 22.0031L46.6221 22.2844L46.9033 22.0031ZM46.3502 22.0031L46.0689 22.2844L46.3502 22.0031ZM46.6314 22.5656L46.3502 22.8375L46.6314 22.5562V22.5656Z",
    fill: "#99CCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwAruba);
export default __webpack_public_path__ + "static/media/aw Aruba.5ca89f026d5ea11a677c58af034f20d5.svg";
export { ForwardRef as ReactComponent };